import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/pages/ErcoLogin';
import Logout from '@/components/pages/ErcoLogout';
import Dashboard from '@/components/pages/ErcoDashboard';
import ObjectView from '@/components/pages/ErcoObjectView';
import LiveView from '@/components/pages/ErcoLiveView';
import User from '@/store/modules/user';
import TextEditor from '@/components/organisms/ErcoTextEditor';

Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: '/login',
			component: Login,
			meta: { requiresAuth: false },
		},
		{
			path: '/logout',
			component: Logout,
			meta: { requiresAuth: false },
		},
		{
			path: '/dashboard',
			component: Dashboard,
			meta: { requiresAuth: true },

		},
		{
			path: '/objectview/:objectId(\\d+)/:view?',
			component: ObjectView,
			meta: { requiresAuth: true },
		},
		{
			path: '/liveview/:objectId(\\d+)/:processview?',
			component: LiveView,
			meta: { requiresAuth: false },
		},
		{
			path: '/texteditor',
			component: TextEditor,
			meta: { requiresAuth: false },
		},

		// Default route
		{
			path: '*',
			meta: { defaultRoute: true },
		},
	],
});

// Protect routes that require authentication

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!User.state.token) {
			next({
				path: '/login',
				query: { redirect: to.fullPath },
			});
		} else {
			next();
		}
	} else if (to.matched.some(record => record.meta.defaultRoute)) {
		next({
			path: '/dashboard',
		});
	} else {
		next();
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js